
<div class="w-100 h-100 fix-parent-height-center-center" *ngIf="loadingCustomData">
  <span class="loader"></span>
</div>

<section class="position-relative animated fadeIn">
  <mat-card appearance="outlined" style="width: 310px; border: 0; margin: 0 auto; padding: 0px 0px" *ngIf="!loadingCustomData" class="bg-white">
    <!-- CUSTOM TITLE -->
    <mat-card-header
      class="p-3 d-flex flex-column justify-content-center align-content-center"
      *ngIf="!loadingCustomData">
      <mat-card-title *ngIf="!!customImgSrc || !!customText" class="m-0 text-center pb-2 px-3">
        <img
          *ngIf="!!customImgSrc"
          class="custom-login-img-responsive d-inline-block align-top"
          [src]="customImgSrc | domSanitizer: 'url'"
          [alt]="'LOGIN.LOGOS.CLIENT-ALT' | translate" />
        <div *ngIf="!!customText" class="h4 m-0 pt-2 text-center">
          {{ customText }}
        </div>
      </mat-card-title>
      <!-- DEFAULT TITLE -->
      <mat-card-title class="m-0 text-center">
        <img *ngIf="theme === 'Redtrust'" src="assets/images/logo/{{theme}}/logo-color.svg" height="50" class="d-inline-block align-top" [alt]="'LOGIN.LOGOS.REDTRUST-ALT' | translate:{ theme: theme }">
      </mat-card-title>
    </mat-card-header>

    <!-- LOGIN FOR USER PIN SET & RESET -->
    <mat-card-content class="px-4 pb-3" *ngIf="loginStep === 'username' || loginStep === 'password'">
      <div class="w-100 d-block pb-1 fw-bold text-secondary font-italic text-center" [class.hidden]="(loginStep === 'username')">{{ loginForm.get('username').value }}</div>

      <form [ngClass]="{'py-4':(!certificateDomainsConfigured && !ssoLoginButtons.length)}" [formGroup]="loginForm">
        <!-- USERNAME -->
        <div [class.hidden]="(loginStep === 'password')">
          <!-- USERNAME -->
          <mat-form-field class="full-width-input w-100">
            <mat-label> {{ 'LOGIN.FORM.USERNAME' | translate }} </mat-label>
            <input
              #username
              matInput
              type="text"
              id="username"
              name="username"
              autocomplete="off"
              formControlName="username"
              (keyup)="($event.key === 'Enter' && username.value) ? this.onSubmitUsername(loginForm.value) : undefined"
              [readonly]="loginStep === 'password'"
              required
              autofocus
              data-selenium="input-login-username" />
            <mat-error *ngIf="isFieldInvalid('username')">
              {{ 'LOGIN.FORM.VALIDATOR.REQUIRE.USERNAME' | translate }}
            </mat-error>
          </mat-form-field>
          <button
            mat-raised-button
            color="primary"
            class="w-100 mt-3 main-button"
            [disabled]="loginForm.get('username').invalid || loadingLogin || loadingLoginCert || loginStep === 'password'"
            type="button"
            (click)="onSubmitUsername(loginForm.value)"
            data-selenium="button-login-username-continue">
            <i class="fas fa-spinner fa-pulse fa-1x" *ngIf="loadingLogin"></i>
            <i class="rt-icon rt-transporte" *ngIf="isMobile && !loadingLogin"></i>
            <span *ngIf="!isMobile && !loadingLogin">{{ 'LOGIN.FORM.BTN-CONTINUE' | translate }}</span>
          </button>
          <p *ngIf="certificateDomainsConfigured || ssoLoginButtons.length || isMobile" class="my-2 w-100 text-center">{{ 'LOGIN.FORM.OR' | translate }}</p>

          <ng-container *ngFor="let button of ssoLoginButtons">
            <button
            mat-stroked-button
            *ngIf="button.domainName"
            color="primary"
            class="w-100 mb-2"
            type="button"
            [disabled]="loadingLogin || loadingLoginCert || ssoLoginClickedButton !== ''"
            (click)="loginWithSso(button.domainName)"
            data-selenium="button-login-sso">
              <i class="fas fa-spinner fa-pulse fa-1x" *ngIf="ssoLoginClickedButton === button.domainName"></i>
              {{ 'LOGIN.FORM.LOGIN-WITH' | translate }} {{ button.domainName }}
            </button>
          </ng-container>

          <button
            *ngIf="!isMobile && certificateDomainsConfigured"
            mat-stroked-button
            color="primary"
            class="w-100"
            type="button"
            [disabled]="loadingLogin || loadingLoginCert"
            (click)="onLoginByCertificate()"
            data-selenium="button-login-certificate">
            <i class="fas fa-spinner fa-pulse fa-1x" *ngIf="loadingLogin || loadingLoginCert"></i>
            <span *ngIf="!loadingLogin && !loadingLoginCert">{{ 'LOGIN.FORM.BTN-CERT' | translate }}</span>
          </button>
        </div>

        <!-- PASSWORD -->
        <div [class.hidden]="(loginStep === 'username')">
          <mat-form-field class="full-width-input w-100">
            <mat-label> {{ 'LOGIN.FORM.PASS' | translate }} </mat-label>
            <input
              #password
              matInput
              id="password"
              name="password"
              autocomplete="password"
              formControlName="password"
              (keyup)="($event.key === 'Enter' && password.value) ? onSubmitPassword(loginForm.value) : undefined"
              required
              autofocus
              [type]="hide ? 'password' : 'text'"
              data-selenium="input-login-password" />
            <i class="rt-icon pointer fs22 mx-1" role="button" aria-label="Show/Hide password" matSuffix [attr.data-selenium]="'toggle-login-password'" (click)="hide = !hide" [ngClass]="{'rt-view': hide, 'rt-hide': !hide}"></i>
            <mat-error *ngIf="isFieldInvalid('password')">
              {{ 'LOGIN.FORM.VALIDATOR.REQUIRE.PASS' | translate }}
            </mat-error>
          </mat-form-field>

          <button
            mat-raised-button
            color="primary"
            class="w-100 mt-3"
            [disabled]="!loginForm.get('password').valid || loadingLogin"
            type="button"
            (click)="onSubmitPassword(loginForm.value)"
            data-selenium="button-login-password-enter">
            <i class="fas fa-spinner fa-pulse fa-1x" *ngIf="loadingLogin"></i>
            <i class="rt-icon rt-transporte" *ngIf="isMobile && !loadingLogin"></i>
            <span *ngIf="!isMobile && !loadingLogin">{{ 'LOGIN.FORM.BTN-ENTER' | translate }}</span>
          </button>
          <p class="my-2 w-100 text-center">{{ 'LOGIN.FORM.OR' | translate }}</p>
          <button
            mat-stroked-button
            color="primary"
            class="w-100"
            type="button"
            [disabled]="loadingLogin || loadingLoginCert"
            (click)="resetForm()"
            data-selenium="button-login-back">
            <i class="fas fa-spinner fa-pulse fa-1x" *ngIf="loadingLogin || loadingLoginCert"></i>
            <i class="rt-icon rt-flecha-izquierda-2" *ngIf="isMobile && !loadingLogin && !loadingLoginCert"></i>
            <span *ngIf="!isMobile && !loadingLogin && !loadingLoginCert">{{ 'LOGIN.FORM.BTN-CHANGE-USER' | translate }}</span>
          </button>
        </div>
      </form>
      <span class="w-100 d-inline-block text-center pt-3">
        <small>{{ 'GLOBAL.PERSONAL-TITLE' | translate }} - </small>
        <small *ngIf="currentVersion">v{{ currentVersion }}</small>
      </span>
    </mat-card-content>
  </mat-card>
</section>
